import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { getTimes, ScheduleEntry, ScheduleService } from '../../services/index';

@Component({
  selector: 'app-program-period',
  templateUrl: './program-period.component.html',
  styleUrls: ['./program-period.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramPeriodComponent {
  @Input()
  programs: { value: string; css?: string }[];
  @Input()
  period: ScheduleEntry;
  @Input()
  resolution: number;
  @Input()
  maxEntries: number;

  @Output()
  startChange: EventEmitter<ScheduleEntry> = new EventEmitter<ScheduleEntry>();
  @Output()
  endChange: EventEmitter<ScheduleEntry> = new EventEmitter<ScheduleEntry>();
  @Output()
  programChange: EventEmitter<ScheduleEntry> = new EventEmitter<ScheduleEntry>();

  constructor(public scheduleService: ScheduleService) {}

  get programCss(): string {
    return this.period.mode
      ? 'program-' + this.period.mode.replace(/\//gm, '-')
      : 'program-default';
  }

  onProgramChange(mode: string): void {
    this.programChange.emit({
      ...this.period,
      mode,
    });
  }

  onStartTimeChange(start: string): void {
    this.startChange.emit({
      ...this.period,
      start,
    });
  }

  onEndTimeChange(end: string): void {
    this.endChange.emit({
      ...this.period,
      end,
    });
  }

  getTimes(from: string, to: string, edge: string): string[] {
    return getTimes(from, to, edge, this.resolution);
  }
}
